/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PagedModelPublistMetadata,
} from '../models/index';
import {
    PagedModelPublistMetadataFromJSON,
    PagedModelPublistMetadataToJSON,
} from '../models/index';

export interface GetKeysbyOrganisationIdRequest {
    orgaId: string;
    page?: number;
    size?: number;
    nameSortDir?: GetKeysbyOrganisationIdNameSortDirEnum;
}

export interface GetKeysbyPersonIdRequest {
    personId: string;
    page?: number;
    size?: number;
    nameSortDir?: GetKeysbyPersonIdNameSortDirEnum;
}

export interface GetKeysbyProjectIdRequest {
    projectId: string;
    page?: number;
    size?: number;
    nameSortDir?: GetKeysbyProjectIdNameSortDirEnum;
}

export interface GetKeysbyUserIdRequest {
    userId: number;
    page?: number;
    size?: number;
    nameSortDir?: GetKeysbyUserIdNameSortDirEnum;
}

export interface GetKeysbyWorkIdRequest {
    workId: number;
    page?: number;
    size?: number;
    nameSortDir?: GetKeysbyWorkIdNameSortDirEnum;
}

/**
 * 
 */
export class PublistKeyApi extends runtime.BaseAPI {

    /**
     * Creates request options for getKeysbyOrganisationId without sending the request
     */
    async getKeysbyOrganisationIdRequestOpts(requestParameters: GetKeysbyOrganisationIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orgaId'] == null) {
            throw new runtime.RequiredError(
                'orgaId',
                'Required parameter "orgaId" was null or undefined when calling getKeysbyOrganisationId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['nameSortDir'] != null) {
            queryParameters['nameSortDir'] = requestParameters['nameSortDir'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publist/key/organisation/{orgaId}`;
        urlPath = urlPath.replace(`{${"orgaId"}}`, encodeURIComponent(String(requestParameters['orgaId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getKeysbyOrganisationIdRaw(requestParameters: GetKeysbyOrganisationIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedModelPublistMetadata>> {
        const requestOptions = await this.getKeysbyOrganisationIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedModelPublistMetadataFromJSON(jsonValue));
    }

    /**
     */
    async getKeysbyOrganisationId(requestParameters: GetKeysbyOrganisationIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedModelPublistMetadata> {
        const response = await this.getKeysbyOrganisationIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getKeysbyPersonId without sending the request
     */
    async getKeysbyPersonIdRequestOpts(requestParameters: GetKeysbyPersonIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getKeysbyPersonId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['nameSortDir'] != null) {
            queryParameters['nameSortDir'] = requestParameters['nameSortDir'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publist/key/person/{personId}`;
        urlPath = urlPath.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters['personId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getKeysbyPersonIdRaw(requestParameters: GetKeysbyPersonIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedModelPublistMetadata>> {
        const requestOptions = await this.getKeysbyPersonIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedModelPublistMetadataFromJSON(jsonValue));
    }

    /**
     */
    async getKeysbyPersonId(requestParameters: GetKeysbyPersonIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedModelPublistMetadata> {
        const response = await this.getKeysbyPersonIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getKeysbyProjectId without sending the request
     */
    async getKeysbyProjectIdRequestOpts(requestParameters: GetKeysbyProjectIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getKeysbyProjectId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['nameSortDir'] != null) {
            queryParameters['nameSortDir'] = requestParameters['nameSortDir'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publist/key/project/{projectId}`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getKeysbyProjectIdRaw(requestParameters: GetKeysbyProjectIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedModelPublistMetadata>> {
        const requestOptions = await this.getKeysbyProjectIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedModelPublistMetadataFromJSON(jsonValue));
    }

    /**
     */
    async getKeysbyProjectId(requestParameters: GetKeysbyProjectIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedModelPublistMetadata> {
        const response = await this.getKeysbyProjectIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getKeysbyUserId without sending the request
     */
    async getKeysbyUserIdRequestOpts(requestParameters: GetKeysbyUserIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getKeysbyUserId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['nameSortDir'] != null) {
            queryParameters['nameSortDir'] = requestParameters['nameSortDir'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publist/key/user/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getKeysbyUserIdRaw(requestParameters: GetKeysbyUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedModelPublistMetadata>> {
        const requestOptions = await this.getKeysbyUserIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedModelPublistMetadataFromJSON(jsonValue));
    }

    /**
     */
    async getKeysbyUserId(requestParameters: GetKeysbyUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedModelPublistMetadata> {
        const response = await this.getKeysbyUserIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getKeysbyWorkId without sending the request
     */
    async getKeysbyWorkIdRequestOpts(requestParameters: GetKeysbyWorkIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['workId'] == null) {
            throw new runtime.RequiredError(
                'workId',
                'Required parameter "workId" was null or undefined when calling getKeysbyWorkId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['nameSortDir'] != null) {
            queryParameters['nameSortDir'] = requestParameters['nameSortDir'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publist/key/work/{workId}`;
        urlPath = urlPath.replace(`{${"workId"}}`, encodeURIComponent(String(requestParameters['workId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getKeysbyWorkIdRaw(requestParameters: GetKeysbyWorkIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedModelPublistMetadata>> {
        const requestOptions = await this.getKeysbyWorkIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedModelPublistMetadataFromJSON(jsonValue));
    }

    /**
     */
    async getKeysbyWorkId(requestParameters: GetKeysbyWorkIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedModelPublistMetadata> {
        const response = await this.getKeysbyWorkIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetKeysbyOrganisationIdNameSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetKeysbyOrganisationIdNameSortDirEnum = typeof GetKeysbyOrganisationIdNameSortDirEnum[keyof typeof GetKeysbyOrganisationIdNameSortDirEnum];
/**
 * @export
 */
export const GetKeysbyPersonIdNameSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetKeysbyPersonIdNameSortDirEnum = typeof GetKeysbyPersonIdNameSortDirEnum[keyof typeof GetKeysbyPersonIdNameSortDirEnum];
/**
 * @export
 */
export const GetKeysbyProjectIdNameSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetKeysbyProjectIdNameSortDirEnum = typeof GetKeysbyProjectIdNameSortDirEnum[keyof typeof GetKeysbyProjectIdNameSortDirEnum];
/**
 * @export
 */
export const GetKeysbyUserIdNameSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetKeysbyUserIdNameSortDirEnum = typeof GetKeysbyUserIdNameSortDirEnum[keyof typeof GetKeysbyUserIdNameSortDirEnum];
/**
 * @export
 */
export const GetKeysbyWorkIdNameSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetKeysbyWorkIdNameSortDirEnum = typeof GetKeysbyWorkIdNameSortDirEnum[keyof typeof GetKeysbyWorkIdNameSortDirEnum];
